"use client";
import React from "react";
import NewPrimaryButton from "../NewPrimaryButton/NewPrimaryButton";
import { FRONTEND_ENDPOINTS } from "../../../../public/Constants/endpoints";
import { getCookie } from "cookies-next";
import {
    SAUDI_ISO,
    EMAIL_STATUS,
    PAYMENT_STATUS,
    SUBMITTED_SURVEY,
    REGISTERED_COUNTRY,
} from "../../../../public/Constants/EnumConstants";

const NewPrimaryButtonWrapper = ({
    text,
    onClick,
    processing,
    width,
    href,
    className,
    style,
    type,
    disabled,
    section,
    buttonId,
    image,
    place,
    event,
    menuName,
    prefetch,
}) => {
    const submitted_survey = getCookie(SUBMITTED_SURVEY);
    const email_verified = getCookie(EMAIL_STATUS);
    const payment_status = getCookie(PAYMENT_STATUS);
    const signup_country = getCookie(REGISTERED_COUNTRY);

    const getURL = (href) => {
        if (
            submitted_survey &&
            email_verified &&
            payment_status &&
            signup_country
        ) {
            if (!submitted_survey) {
                return FRONTEND_ENDPOINTS?.SURVEY;
            }

            if (!email_verified) {
                return FRONTEND_ENDPOINTS?.SURVEY_COMPLETE;
            }

            switch (payment_status) {
                case "un_paid":
                    return FRONTEND_ENDPOINTS?.CHECKOUT_ADDRESS;
                case "paid":
                    return FRONTEND_ENDPOINTS?.DASHBOARD;
                default:
                    return href;
            }
        }
        return href;
    };
    return (
        <NewPrimaryButton
            text={text}
            onClick={onClick}
            processing={processing}
            width={width}
            href={getURL(href)}
            className={className}
            style={style}
            type={type}
            disabled={disabled}
            section={section}
            buttonId={buttonId}
            image={image}
            place={place}
            googleEventName={event}
            menuName={menuName}
            prefetch={prefetch}
        />
    );
};

export default NewPrimaryButtonWrapper;
